import { cn } from "@wags/ui/ui-utils";
import type { Review } from "@/components/shared/ReviewsSection";

export function MobileReviewCarousel({
    reviews,
    contextLabel,
    elevated = false,
    scrollRestorationId,
}: {
    reviews: Review[];
    contextLabel: (review: Review) => string;
    elevated?: boolean;
    scrollRestorationId?: string;
}) {
    return (
        <div
            data-scroll-restoration-id={scrollRestorationId}
            className="mt-4 pt-2 pb-2 full-bleed-scroll flex gap-3 overflow-x-auto snap-x snap-mandatory scrollbar-none md:hidden"
        >
            {reviews.map((r) => (
                <div
                    key={r.id}
                    className={cn(
                        "w-[220px] shrink-0 snap-start rounded-card bg-true-white p-card flex flex-col gap-3",
                        elevated
                            ? "border-shadow"
                            : "border border-doberman-black/8",
                    )}
                >
                    <p className="text-body-small text-doberman-black/80 line-clamp-6">
                        {r.text}
                    </p>
                    <p className="text-body-small text-doberman-black/45">
                        {[r.author.split(" ")[0], contextLabel(r)]
                            .filter(Boolean)
                            .join(" · ")}
                    </p>
                </div>
            ))}
        </div>
    );
}
